let API_URL = "";

if (window.location.hostname === "localhost") {
  API_URL = "http://localhost:5003";
}
else {
  API_URL = "";
}

// ── Admin session inactivity policy ─────────────────────────────────────────
// Recruiters are not required to sign in often, so a stale tab can sit open for
// days. These values drive the idle/absolute session timeout in AuthContext so
// an abandoned session is signed out cleanly (instead of surfacing a runtime
// error when a long-expired token is finally used). All values are overridable
// at build time via REACT_APP_* env vars; sensible defaults are applied here so
// nothing is hard-coded inside the components themselves.
const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;

const toPositiveNumber = (value, fallback) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

// Sign the recruiter out after this much continuous inactivity (no mouse,
// keyboard, scroll or touch). Default: 8 hours.
export const SESSION_IDLE_TIMEOUT_MS = toPositiveNumber(
  process.env.REACT_APP_SESSION_IDLE_TIMEOUT_MS,
  8 * HOUR_MS
);

// Hard cap on a single session regardless of activity, measured from when the
// JWT was issued. Default: 24 hours. (The backend JWT also expires on its own;
// whichever limit is reached first wins.)
export const SESSION_ABSOLUTE_TIMEOUT_MS = toPositiveNumber(
  process.env.REACT_APP_SESSION_ABSOLUTE_TIMEOUT_MS,
  24 * HOUR_MS
);

// How often the idle/absolute timeouts are re-evaluated. Default: 1 minute.
export const SESSION_ACTIVITY_CHECK_INTERVAL_MS = toPositiveNumber(
  process.env.REACT_APP_SESSION_CHECK_INTERVAL_MS,
  MINUTE_MS
);

// Persisting the activity timestamp on every mousemove would thrash
// localStorage, so writes are throttled to at most once per this window.
// Default: 10 seconds.
export const SESSION_ACTIVITY_WRITE_THROTTLE_MS = toPositiveNumber(
  process.env.REACT_APP_SESSION_ACTIVITY_WRITE_THROTTLE_MS,
  10 * SECOND_MS
);

// Storage keys shared between AuthContext (writer) and the login screen
// (reader of the "session expired" flag). Centralized here to avoid drift.
export const SESSION_LAST_ACTIVITY_KEY = "admin_last_activity";
export const SESSION_EXPIRED_FLAG = "admin_session_expired";

// ── Active environment (deploy-time global, NO Mongo/settings API call) ───────
// The client NEVER reads process.env.NODE_ENV and does NOT hit a public settings
// endpoint. If a value is genuinely needed in the browser (here: only to gate
// verbose debug logging), deployment can expose it via a static, deploy-generated
// `window.__CROWDPLAT_ENV__` (e.g. a runtime-config.js emitted per environment).
// Absent that, we default to "production" — the safe, quiet choice (debug off).
export const getEnv = () =>
  (typeof window !== "undefined" && window.__CROWDPLAT_ENV__) || "production";
export const isProductionEnv = () => getEnv() === "production";

export default API_URL;